<template>
  <div class="assign-license-component w-[833px] mt-[35px] m-auto">
    <el-form
      ref="refAssignPlayerLicenseForm"
      :model="model"
      :rules="modelRules"
      class="common-form mt-4">
      <el-row class="flex-row w-full flex-row flex justify-left items-end mt-[7px]">
        <div class="w-[180px] mr-[36px]">
          <h2 class="capitalize text-base text-black font-bold block text-left mb-[15px]">{{ $t("activation.comment") }}</h2>
          <el-form-item class="assign-license-comment">
            <input
              v-model="model.comment"
              class="border-0 border-b outline-hidden border-black bg-transparent text-base text-black w-full font-medium"
              @keyup.enter="handleSubmitForm" />
          </el-form-item>
        </div>

        <div class="w-[180px] mr-[36px]">
          <h2 class="capitalize text-base text-black font-bold block text-left mb-[15px]">{{ $t("activation.playerSerialNumber") }}</h2>
          <el-form-item class="assign-license-serial-number">
            <input
              v-model="model.playerSerialNumber"
              class="border-0 border-b outline-hidden border-black bg-transparent text-base text-black w-full font-medium font-roboto-mono"
              @keyup.enter="handleSubmitForm" />
          </el-form-item>
        </div>

        <div class="w-[180px] mr-[73px]">
          <h2 class="capitalize text-base text-black font-bold block text-left mb-[15px]">{{ $t("activation.licenseCode") }}</h2>
          <el-form-item prop="licenseCode" class="assign-license-license-code text-left">
            <input
              v-model="model.licenseCode"
              class="border-0 border-b outline-hidden border-black bg-transparent text-base text-black w-full font-medium font-roboto-mono"
              @keyup.enter="handleSubmitForm" />
          </el-form-item>
        </div>

        <div class="w-[146px] mb-[2px]">
          <button
            type="button"
            class="rounded-full w-[146px] h-[36px] px-4 py-[5px] text-base text-white font-medium block bg-[#6179E7] border-none mb-[7px] truncate"
            @click="handleSubmitForm()">
              {{ $t("activation.assign") }}
            </button>
        </div>
      </el-row>
    </el-form>
  </div>
</template>

<script src="./assign-license.js"></script>
